<template>
  <div class="insure-form">
    <div class="title">确认投保人信息和付款方式</div>
    <div class="cell">
      <span>投保人信息</span>
      <span @click="showAddDialogHandle"
        >+新增投保人信息({{ nowPersonCount }}/3)</span
      >
    </div>

    <div class="form-wrapper">
      <div v-if="personList.length > 0">
        <div
          class="person-list"
          v-for="item in personList"
          :key="item.id"
          @click="chooseHandle(item)"
          :class="select === item.id ? 'select-item' : ''"
        >
          <el-row>
            <el-col
              :span="22"
              class="status-text"
              :style="{ color: statusColor[item.status] }"
              ><span
                class="status-logo"
                :class="
                  item.status === 0
                    ? 'status-logo-warning'
                    : item.status === 1
                    ? 'status-logo-success'
                    : 'status-logo-err'
                "
              ></span
              ><span class="status">{{ text[item.status] }}</span
              ><span class="error-text" v-if="item.status == 2 && item.remark"
                >({{ item.remark }})</span
              ></el-col
            >
            <el-col :span="1" v-if="item.status !== 0"
              ><img
                @click="editHandle(item)"
                src="@/assets/images/insure/edit.png"
                alt=""
            /></el-col>
            <el-col :span="1" v-if="item.status !== 0"
              ><img
                @click="delHandle(item.id)"
                src="@/assets/images/insure/del.png"
                alt=""
            /></el-col>
          </el-row>
          <el-divider></el-divider>
          <el-row>
            <el-col :span="8">单位名称：{{ farmInfo.farmName }}</el-col>
            <el-col :span="8"
              >单位类型：{{
                item.appliType == 1
                  ? "个人"
                  : item.appliType == 2
                  ? "单位"
                  : "--"
              }}</el-col
            >
            <el-col :span="8">投保人：{{ item.appliName }}</el-col>
          </el-row>
          <el-row>
            <el-col :span="8"
              >证件类型：{{
                item.identifyType == "01"
                  ? "身份证"
                  : item.identifyType == "03"
                  ? "护照"
                  : item.identifyType == "70"
                  ? "营业执照信用代码"
                  : "--"
              }}</el-col
            >
            <el-col :span="8">证件号码： {{ item.identifyNumber }}</el-col>
            <el-col :span="8">证件有效期：{{ item.validDate }}</el-col>
          </el-row>
          <el-row>
            <el-col :span="8">联系人姓名：{{ item.linkerName }}</el-col>
            <el-col :span="8">联系人电话：{{ item.phoneNumber }}</el-col>
            <el-col :span="8">经营地址：{{ item.appliAddress }}</el-col>
          </el-row>
          <el-divider></el-divider>
          <el-row>
            <el-col :span="16">收款人名称：{{ item.accountName }}</el-col>
            <el-col :span="8">收款银行账号：{{ item.accountCode }}</el-col>
          </el-row>

          <el-row>
            <el-col :span="16">被保人：{{ item.insuredName }}</el-col>
            <el-col :span="8">开户支行：{{ item.bankBranchName }}</el-col>
          </el-row>
        </div>
      </div>
      <div v-else class="no-data">暂无可选投保人信息，请添加</div>
    </div>

    <div class="cell" style="margin-top: 28px">
      <span>付款方式</span>
    </div>

    <div class="pay-method">
      <el-form :model="paymethodForm" :rules="payRules">
        <el-form-item label="付款方式" prop="payType">
          <el-radio-group v-model="paymethodForm.payType">
            <el-radio :label="1">
              <div class="online">
                <span>线上支付</span>
                <img src="@/assets/images/insure/pay_online_new.png" alt="" />
              </div>
            </el-radio>
            <br />
            <el-radio :label="0">线下支付</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
    </div>

    <div class="tips">保费在订单生成后由系统计算得出，请确认后再付款</div>

    <div class="btns-groups">
      <el-button class="prev btn" @click="clickPrevStep">上一步</el-button>
      <el-button
        class="submit btn"
        type="primary"
        @click="submitForm"
        :loading="btnLoading"
        >立即投保</el-button
      >
    </div>
    <form-box
      @changeStatus="changeStatus"
      :editInfo="editInfo"
      :show="showAddDialog"
      ref="userInfoForm"
      class="form-box"
    ></form-box>
    <form-ph
      @changeStatus="changeStatus"
      :editInfo="editInfo"
      :show="showAddDialogPh"
      ref="userInfoFormPh"
      class="form-ph"
    >
    </form-ph>
  </div>
</template>
<script>
import FormBox from "./Form";
import FormPh from "./FormPh";
import {
  addFarmInsureOrder,
  getPolicyholderGetByFarmId,
  delPersonInfo,
  getPolicyholderInfo,
} from "@/api/request/snkd.produce";
import { getStorage } from "@/utils/storage";
import { mapState, mapGetters } from "vuex";
const statusColor = ["#21C074", "#21C074", "#F56C6C"];
const text = ["认证中", "已认证", "认证失败"];
export default {
  components: { FormBox, FormPh },
  data() {
    return {
      showForm: true,
      showAddDialog: false,
      personList: [],
      nowPersonCount: 0,
      // 支付方式表单
      paymethodForm: {
        payType: 1,
      },
      payRules: {
        payType: [
          {
            type: "number",
            required: true,
            message: "请选择付款方式",
            trigger: "change",
          },
        ],
      },
      btnLoading: false,
      editInfo: {},
      text,
      statusColor,
      select: null,
      chooseInfo: {},
      listLoading: false,
      addFlag: false,
      showAddDialogPh: false,
      farmInfo: {},
    };
  },
  mounted() {
    this.farmInfo = getStorage("FARMINFO");
    this.getPersonListServe();
  },
  computed: {
    ...mapState({
      companyId: (state) => state.companyId,
      farmId: (state) => state.farmId,
      insureId: (state) => state.insure.insureId,
    }),
    ...mapGetters({
      hadSelectedLandList: "insure/hadSelectedLandList",
    }),
  },
  methods: {
    //编辑投保人姓名
    editHandle(info) {
      this.editInfo = info;
      this.showAddDialogPh = true;
      this.$forceUpdate();
    },
    //选择投保人
    chooseHandle(info) {
      this.select = info.id;
      this.chooseInfo = info;
    },
    //新增联系人弹框
    showAddDialogHandle() {
      if (this.nowPersonCount >= 3) {
        this.$message({ message: "最多添加三条投保人信息", type: "warning" });
      } else {
        this.getPolicyholderInfoFn();
      }
    },
    //获取投保人信息
    async getPolicyholderInfoFn() {
      const res = await getPolicyholderInfo({
        companyId: this.companyId.toString() + this.farmId.toString(),
      });
      if (res.obj) {
        this.editInfo = res.obj;
        this.showAddDialogPh = true;
        this.$forceUpdate();
      }
    },

    changeStatus(info) {
      this.showAddDialog = info;
      this.showAddDialogPh = info;
      this.getPersonListServe();
    },
    clickPrevStep() {
      this.$emit("prev-step", "VerifyList");
    },
    //获取保险人列表
    async getPersonListServe() {
      const res = await getPolicyholderGetByFarmId({
        companyId: this.companyId,
        farmId: this.farmId,
      });
      if (res.obj) {
        this.personList = res.obj;
        this.nowPersonCount = this.personList.length;
      } else {
        this.personList = [];
      }
    },
    //删除投保人信息
    async delHandle(id) {
      this.$confirm("是否确认删除投保人信息", "提示", {
        showClose: true,
        type: "warning",
        customClass: "message-box-height",
      })
        .then(async () => {
          const res = await delPersonInfo({
            id,
          });
          if (res.respCode === 0) {
            this.$message({
              message: "删除成功",
              type: "success",
            });
            this.select = null;
            this.chooseInfo = null;
            this.getPersonListServe();
          }
        })
        .catch(() => {});
    },
    //立即投保
    async submitForm() {
      if (!this.select) {
        this.$message({
          message: "请选择投保人信息",
          type: "error",
        });
        return;
      }
      if (this.btnLoading) {
        return;
      }
      this.btnLoading = true;
      const params = {
        coListInsureOrderLandRespList: this.hadSelectedLandList,
        companyId: this.companyId,
        farmId: this.farmId,
        farmInsureAddReq: this.chooseInfo,
        insureId: this.insureId,
        payType: this.paymethodForm.payType,
      };
      addFarmInsureOrder(params).then((res) => {
        console.log("投保结果：", res);
        this.btnLoading = false;
        if (res.respCode == 300 || res.respCode == 404) {
          const respDesc = this.formatStr(res.respDesc, "$");
          const msgHtml = `失败原因：<br>${respDesc.split("$").join("<br>")}`;
          this.$alert(msgHtml, "投保失败", {
            confirmButtonText: "确定",
            dangerouslyUseHTMLString: true,
          });
        }
        if (res.respCode == 70002) {
          const msgHtml = `失败原因：<br>${res.respDesc
            .split(",")
            .join("<br>")}`;
          this.$alert(msgHtml, "投保失败", {
            confirmButtonText: "确定",
            dangerouslyUseHTMLString: true,
          });
        }
        if (res.respCode == 0) {
          this.$message({
            message: "已生成订单，请确认并支付",
            type: "success",
          });
          setTimeout(() => {
            // 退出投保页面时，清空一些状态
            this.$store.commit("insure/clearInsurePageStatus");
            this.$router.push({
              name: "DetailsIndex",
              query: {
                type: 2,
                id: res.obj.orderId,
              },
            });
          }, 2000);
        }
      });
    },
    formatStr(str, flag = "$") {
      let res = str;
      [";", "；"].forEach((s) => {
        res = res.replace(new RegExp(s, "g"), flag);
      });
      return res;
    },
  },
};
</script>
<style lang="scss" scoped>
.insure-form {
  background: #ffffff;
  padding: 0 100px 158px;
  .el-col {
    overflow: hidden; //溢出内容隐藏
    text-overflow: ellipsis; //文本溢出部分用省略号表示
    white-space: nowrap;
  }
  .title {
    font-weight: 600;
    font-size: 22px;
    color: #333333;
    padding: 40px 0;
    text-align: center;
  }
  .cell {
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    height: 60px;
    background: #f7f9fb;
    color: $--color-primary;
    font-size: 18px;
    padding: 0 23px 0 16px;
    cursor: pointer;
    i.icon {
      font-weight: bold;
      transition: all 0.5s;
      &.active {
        transform: rotate(-180deg);
      }
    }
    i.text {
      transition: all 0.5s;
      font-size: 16px;
      margin-right: 10px;
    }
  }
  .form-wrapper {
    padding: 10px 0 10px;
    font-size: 15px;
    color: #666;
    .person-list {
      padding: 10px 15px;
      background-color: #f7f9fb;
      margin-bottom: 10px;

      &:hover {
        box-shadow: 0px 5px 20px rgba(100, 195, 164, 0.2);
        background-color: #fcfcfc;
      }
      img {
        width: 25px;
        height: 25px;
        cursor: pointer;
      }
      .status-text {
        height: 33px;
        font-size: 18px;
        font-weight: bold;
        display: flex;
        align-items: center;
        .error-text {
          color: #f56c6c;
          margin-left: 10px;
          font-weight: normal;
          font-size: 14px;
        }
      }
      .status-logo {
        margin-right: 10px;
        display: inline-block;
        background-size: 100% 100%;
        width: 25px;
        height: 25px;
      }
      .status-logo-success {
        background: url("~@/assets/images/insure/success.png") no-repeat;
        background-size: cover;
      }
      .status-logo-warning {
        background: url("~@/assets/images/insure/warning.png") no-repeat;
        background-size: cover;
      }
      .status-logo-err {
        background: url("~@/assets/images/insure/err.png") no-repeat;
        background-size: cover;
      }
      ::v-deep .el-divider--horizontal {
        margin: 15px 0;
      }
    }
    .select-item {
      border: 1px solid #64c3a4;
      box-shadow: 0px 5px 20px rgba(100, 195, 164, 0.2);
      background-color: #fcfcfc;
    }

    .no-data {
      text-align: center;
      color: #bdc0c3;
      height: 300px;
      line-height: 300px;
    }
    .el-row {
      height: 30px;
      line-height: 30px;
    }
  }
  .pay-method {
    display: flex;
    margin-top: 30px;
    padding-left: 310px;
    .title {
      font-size: 16px;
      color: #333333;
    }
    .online {
      display: inline-flex;
      align-items: center;
      img {
        width: 332px;
        height: 80px;
        margin-left: 39px;
        cursor: default;
      }
    }
    ::v-deep .el-form-item {
      display: flex;
      .el-form-item__label {
        box-sizing: border-box;
        padding-top: 20px;
        margin-right: 55px;
      }
    }
  }
  .tips {
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: #ff831e;
    text-align: center;
    margin-top: 20px;
  }
  .btns-groups {
    margin-top: 48px;
    text-align: center;
    .prev {
      width: 122px;
      margin-right: 14px;
      color: $--color-primary;
      border-color: $--color-primary;
    }
    .submit {
      width: 136px;
    }
  }
}
</style>
